export default __webpack_public_path__ + "static/media/check-in-daily-ico.e8fc5b63.svg";